require("../../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js");

module.exports = {
  init: () => {
    $(".videopopup").each(function() {
      $(this).magnificPopup({
        type: "iframe"
      });
    });

    $(".popup-trigger").each(function() {
      $(this).magnificPopup({
        type: "inline",
        preloader: false,
        focus: "#name",
        mainClass: "mfp-fade",
        removalDelay: 300,

        // When elemened is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
          beforeOpen: function() {
            if ($(window).width() < 700) {
              this.st.focus = false;
            } else {
              this.st.focus = "#name";
            }
          }
        }
      });
    });

    $(".damages-slideshow").each(function() {
      $(this)
        .find(".damages-slideshow-item")
        .magnificPopup({
          type: "image",
          gallery: {
            enabled: true,
            preload: [1, 2],
            arrowMarkup: '<span title="%title%" class="mfp-arrow mfp-arrow-%dir%"><i class="fal fa-chevron-%dir% mfp-prevent-close"></i></span>'
          }
        });
    });

    // if ($("#corona-popup").length) {
    //   $.magnificPopup.open({
    //     items: {
    //       src: $("#corona-popup")
    //     },
    //     type: "inline",
    //     callbacks: {
    //       afterClose: function() {
    //         $(".teaser-popup")
    //           .show()
    //           .css("height", 0)
    //           .animate({ height: 223 });
    //       },
    //       beforeOpen: function() {
    //         if ($(window).width() < 700) {
    //           this.st.focus = false;
    //         } else {
    //           this.st.focus = "#name";
    //         }
    //       }
    //     }
    //   });
    // }
  }
};
